var map = {
	"./activity-log-grey.svg": 98512,
	"./activity-log.svg": 34576,
	"./additional-detail-white.svg": 87229,
	"./additional-detail.svg": 73881,
	"./announcement-green.svg": 18153,
	"./announcement.svg": 35231,
	"./app-screen-green.svg": 14094,
	"./app-screen-orange.svg": 65587,
	"./app-screen-white.svg": 60572,
	"./app-screen.svg": 99660,
	"./apple-logo.svg": 10678,
	"./arrow-circle-right.svg": 14775,
	"./arrow-down-green.svg": 62404,
	"./arrow-down.svg": 30222,
	"./arrow-left-grey.svg": 45203,
	"./arrow-left.svg": 39845,
	"./arrow-narrow-up-right.svg": 27822,
	"./arrow-right-black.svg": 65154,
	"./arrow-right-green.svg": 34578,
	"./arrow-right.svg": 91720,
	"./attendance-green.svg": 69241,
	"./attendance-media-grey.svg": 21116,
	"./attendance-media.svg": 34044,
	"./attendance.svg": 67535,
	"./bar-chart-horizontal-grey.svg": 72989,
	"./bar-chart-vertical-grey.svg": 74911,
	"./bell-icon.svg": 24005,
	"./billing.svg": 68475,
	"./bold.svg": 83443,
	"./bound.svg": 80354,
	"./brand-logo-black.svg": 21089,
	"./brand-logo-white.svg": 65271,
	"./brand-logo.svg": 80951,
	"./calendar-date-time.svg": 13417,
	"./calendar-grey.svg": 6992,
	"./calendar-old-grey.svg": 2424,
	"./calendar-old.svg": 98696,
	"./calendar-plus.svg": 60953,
	"./calendar.svg": 81072,
	"./camera-plus.svg": 29488,
	"./cancel.svg": 8708,
	"./check-box-group.svg": 84872,
	"./check-box-square.svg": 85566,
	"./check-circle-broken-blue.svg": 66932,
	"./check-done.svg": 88143,
	"./check-grey.svg": 27750,
	"./check-list-grey.svg": 61185,
	"./check-list.svg": 11247,
	"./check-with-circle.svg": 96212,
	"./check.svg": 53658,
	"./chevron-grey.svg": 46429,
	"./chevron.svg": 29067,
	"./circle-hollow.svg": 46670,
	"./clip-green.svg": 39362,
	"./clip-grey.svg": 43272,
	"./clock-grey.svg": 36640,
	"./clock-plus.svg": 4681,
	"./clock.svg": 95904,
	"./collapse-white.svg": 39851,
	"./color-scheme-white.svg": 34581,
	"./color-scheme.svg": 11073,
	"./company-detail-white.svg": 56355,
	"./company-detail.svg": 35171,
	"./company-field.svg": 12036,
	"./company-profile-green.svg": 17009,
	"./company-profile.svg": 72967,
	"./company-settings-white.svg": 49759,
	"./company-settings.svg": 79,
	"./company-setup.svg": 1775,
	"./company.svg": 79567,
	"./copy-grey.svg": 25967,
	"./copy.svg": 73761,
	"./cross-grey.svg": 95494,
	"./cross.svg": 8026,
	"./dashboard-arrow-bottom.svg": 91726,
	"./dashboard-arrow-right.svg": 92775,
	"./dashboard-grey.svg": 81750,
	"./dashboard-page-empty.svg": 21050,
	"./dashboard.svg": 99274,
	"./data-flow.svg": 5715,
	"./data-source-green.svg": 65638,
	"./data-source.svg": 46468,
	"./database-export.svg": 64600,
	"./defaultIamge.jpg": 92884,
	"./delete.svg": 17779,
	"./directory.svg": 39791,
	"./done-circle-green-filled.svg": 21034,
	"./dot-grey.svg": 79713,
	"./dot-points.svg": 11589,
	"./double-arrow-left.svg": 97769,
	"./double-arrow-right.svg": 78772,
	"./double-check-green.svg": 29980,
	"./double-down-arrow-black.svg": 70376,
	"./double-down-arrow-white.svg": 70406,
	"./double-down-arrow.svg": 35402,
	"./double-up-arrow-white.svg": 37605,
	"./doughnut-chart-grey.svg": 32789,
	"./download-green-underlined.svg": 94149,
	"./download.svg": 59474,
	"./drag-drop.svg": 22690,
	"./drag-icon.svg": 12106,
	"./dropdown-arrow-green.svg": 68655,
	"./dropdown-arrow-grey.svg": 76423,
	"./dropdown-arrow-white.svg": 9645,
	"./dropdown.svg": 33981,
	"./duplicate.svg": 10509,
	"./edit-black.svg": 98332,
	"./edit-circle.svg": 72011,
	"./edit-green.svg": 25156,
	"./edit-grey.svg": 16634,
	"./edit-square-grey.svg": 10454,
	"./edit.svg": 23374,
	"./ellipse.svg": 19468,
	"./export-grey.svg": 78180,
	"./eye-off-green.svg": 47167,
	"./eye-off-grey.svg": 72183,
	"./eye-off.svg": 12761,
	"./eye.svg": 61589,
	"./field-collapse-grey.svg": 51606,
	"./field-collapse.svg": 18762,
	"./field_preview_Icon.svg": 34365,
	"./file-pdf.svg": 14997,
	"./file-plus-green.svg": 92263,
	"./file-plus.svg": 28993,
	"./file.svg": 19880,
	"./filter-grey.svg": 16184,
	"./filter-lines-grey.svg": 94242,
	"./filter-lines.svg": 89990,
	"./filter.svg": 63720,
	"./folder-hidden.svg": 12327,
	"./folder-locked.svg": 55349,
	"./form-blue.svg": 13593,
	"./form-edit-icon.svg": 58389,
	"./form-green.svg": 55650,
	"./form-grey.svg": 26984,
	"./form-name-image.jpg": 58510,
	"./form-published.svg": 95781,
	"./google-play-logo.svg": 66566,
	"./graph-green.svg": 40384,
	"./graph-grey.svg": 16910,
	"./grip-vertical.svg": 85857,
	"./group-users-green.svg": 43038,
	"./group-users-white.svg": 30924,
	"./groups.svg": 4882,
	"./guard-white.svg": 82425,
	"./guest.svg": 16870,
	"./hash.svg": 55886,
	"./heatmap-table-grey.svg": 34463,
	"./help-circle.svg": 64488,
	"./help-green.svg": 24461,
	"./help.svg": 97291,
	"./home-grey.svg": 71821,
	"./home.svg": 25179,
	"./image.svg": 12225,
	"./import.svg": 55265,
	"./infinity.svg": 84970,
	"./info-box-white.svg": 31998,
	"./info-circle-green.svg": 62433,
	"./info-circle-red.svg": 16661,
	"./info-circle-white.svg": 76855,
	"./info-circle.svg": 25879,
	"./info-square.svg": 41830,
	"./instruction-grey.svg": 59018,
	"./issues-green.svg": 46548,
	"./issues-grey.svg": 95786,
	"./issues.svg": 19230,
	"./italic.svg": 74366,
	"./kebab-menu.svg": 8619,
	"./key.svg": 65167,
	"./label.svg": 68484,
	"./layers.svg": 46288,
	"./layout-bottom-white.svg": 55744,
	"./layout-top-white.svg": 24838,
	"./line-graph-grey.svg": 39637,
	"./link-black.svg": 89904,
	"./link-broken-red.svg": 62006,
	"./link-external-grey.svg": 12262,
	"./link-external.svg": 50778,
	"./link-green.svg": 67184,
	"./list.svg": 50710,
	"./location-grey.svg": 31697,
	"./location.svg": 37151,
	"./lock-grey.svg": 46437,
	"./lock-orange.svg": 25314,
	"./long-arrow-right.svg": 40565,
	"./mail-white.svg": 25991,
	"./mail.svg": 48839,
	"./map-pin.svg": 51762,
	"./map-radius.svg": 21143,
	"./map.svg": 9352,
	"./menu-grey.svg": 52493,
	"./message-alert-blue.svg": 44771,
	"./message-alert-grey.svg": 96006,
	"./message-alert-red.svg": 73336,
	"./message-question-circle.svg": 48041,
	"./message-square-grey.svg": 85163,
	"./mic.svg": 65187,
	"./minimize.svg": 57706,
	"./minus.svg": 39238,
	"./monitor.svg": 8368,
	"./movie-grey.svg": 54950,
	"./movie.svg": 55962,
	"./note-grey.svg": 1634,
	"./note.svg": 10886,
	"./number-slider.svg": 58797,
	"./number.svg": 36409,
	"./owner-detail-white.svg": 35503,
	"./owner-detail.svg": 48511,
	"./page-grey.svg": 53633,
	"./page.svg": 81775,
	"./page_edit_circle.svg": 6749,
	"./panel.svg": 84716,
	"./paper-clip-grey.svg": 39037,
	"./pass-lock.svg": 48123,
	"./pdf-file-grey.svg": 33153,
	"./pdf-label-icon.svg": 76421,
	"./pdf-page-grey.svg": 68368,
	"./pdf-page.svg": 85456,
	"./person.svg": 37521,
	"./phone.svg": 282,
	"./photo-grey.svg": 59406,
	"./photo.svg": 49842,
	"./pie-chart-grey.svg": 68001,
	"./play-white.svg": 40176,
	"./play.svg": 7840,
	"./plus-circle-filled-green.svg": 32726,
	"./plus-grey-2.svg": 65499,
	"./plus-grey.svg": 10746,
	"./plus.svg": 68718,
	"./profile-edit-green-icon.svg": 47698,
	"./profile-green.svg": 80343,
	"./profile-grey.svg": 71391,
	"./profile-lock-icon.svg": 7667,
	"./profiles.svg": 13312,
	"./qr-code-green.svg": 68665,
	"./qr-code.svg": 95951,
	"./records.svg": 22968,
	"./rectangle.svg": 66133,
	"./recycle-white.svg": 28525,
	"./refresh-ccw.svg": 46353,
	"./repeat.svg": 80619,
	"./reports.svg": 57367,
	"./required.svg": 65525,
	"./response-set-green.svg": 29854,
	"./response-set.svg": 68252,
	"./ring-blue.svg": 2141,
	"./ring-red.svg": 47286,
	"./ring-yellow.svg": 66733,
	"./save.svg": 32649,
	"./schedule.svg": 79961,
	"./search.svg": 30490,
	"./section-collapse.svg": 1401,
	"./section-grey.svg": 8509,
	"./section.svg": 75659,
	"./send.svg": 63988,
	"./setting-4.svg": 62177,
	"./setting-grey.svg": 43650,
	"./setting.svg": 31270,
	"./share-on-mobile.svg": 8778,
	"./signature.svg": 51460,
	"./sketch.svg": 8874,
	"./smile.svg": 58230,
	"./sort-arrows-grey.svg": 57631,
	"./sorting-icon-grey.svg": 38936,
	"./sorting-icon.svg": 22792,
	"./speedometer-grey.svg": 70295,
	"./stacked-bar-chart-horizontal-grey.svg": 57909,
	"./stacked-bar-chart-vertical-grey.svg": 59911,
	"./star.svg": 35034,
	"./stats-card-grey.svg": 88446,
	"./strikethrough.svg": 45887,
	"./submission-attachment.svg": 44856,
	"./submission-divider.svg": 40818,
	"./support.svg": 71703,
	"./swap-down.svg": 52056,
	"./swap-up.svg": 53035,
	"./table-icons.svg": 58699,
	"./table-properties.svg": 94164,
	"./table.svg": 6430,
	"./tag-grey.svg": 86230,
	"./tasks-grey.svg": 93024,
	"./tasks-old.svg": 39000,
	"./tasks.svg": 35296,
	"./template.svg": 12448,
	"./text-block-grey.svg": 99069,
	"./text.svg": 5031,
	"./ticket-grey.svg": 15554,
	"./ticket.svg": 3046,
	"./tier1.svg": 88319,
	"./tier2.svg": 9292,
	"./time-infinity-grey.svg": 78534,
	"./tools-green.svg": 27837,
	"./translate.svg": 95964,
	"./trash-breadcrumb.svg": 74970,
	"./trash-grey.svg": 54084,
	"./trash-menu.svg": 43948,
	"./trash-red-2.svg": 68399,
	"./trash-red.svg": 64550,
	"./trash.svg": 78196,
	"./triangle-green.svg": 33464,
	"./triangle.svg": 66858,
	"./un-bound.svg": 67288,
	"./underline.svg": 32094,
	"./upload-white.svg": 82549,
	"./user-directory-2.svg": 16860,
	"./user-directory-green.svg": 39371,
	"./user-edit.svg": 70176,
	"./user-grey.svg": 2861,
	"./user-right.svg": 80058,
	"./users-circle-green.svg": 30697,
	"./users-green.svg": 27264,
	"./users.svg": 10290,
	"./vertical-box-group.svg": 17094,
	"./video-plus.svg": 44832,
	"./warning-red.svg": 36644,
	"./whatsapp.svg": 12700
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10771;